import { ResultHighlight, SearchDocument } from '@backstage/plugin-search-common';
import { HighlightedSearchResultText, createSearchResultListItemExtension } from '@backstage/plugin-search-react';
import { searchPlugin } from '@backstage/plugin-search';
import { Link } from '@backstage/core-components';
import ListItemText from '@material-ui/core/ListItemText';

type MarketplaceSearchDocument = SearchDocument & {
  productId?: string;
};

type Props = {
  result?: SearchDocument;
  highlight?: ResultHighlight;
  noTrack?: boolean;
};

function MarketplaceSearchResultListItemComponent({ result, highlight, noTrack }: Props) {
  if (!result) return null;

  const doc = result as MarketplaceSearchDocument;
  const to = doc.location;

  const title = highlight?.fields.title
    ? <HighlightedSearchResultText text={highlight.fields.title} preTag={highlight.preTag} postTag={highlight.postTag} />
    : doc.title;

  const description = highlight?.fields.text
    ? <HighlightedSearchResultText text={highlight.fields.text} preTag={highlight.preTag} postTag={highlight.postTag} />
    : doc.text;

  return (
    <ListItemText
      primaryTypographyProps={{ variant: 'h6' }}
      primary={<Link noTrack={noTrack} to={to}>{title}</Link>}
      secondary={description}
    />
  );
}

export { MarketplaceSearchResultListItemComponent };

export const MarketplaceSearchResultListItem = searchPlugin.provide(
  createSearchResultListItemExtension({
    name: 'MarketplaceSearchResultListItem',
    component: async () => MarketplaceSearchResultListItemComponent,
    predicate: result => result.type === 'marketplace',
  }),
);
